(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/bankid/fallback.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/bankid/fallback.js');

'use strict';

const AuthenticateEvents = svs.accountservices.authenticate.definitions.Events;
svs.player_login.views.bankid.Fallback = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.bankid_fallback(data);
  },
  behaviors: {
    InputSsn: {
      behaviorClass: svs.player_login.behaviors.InputSsn
    },
    Login: {
      behaviorClass: svs.player_login.behaviors.Login
    },
    Navigation: {
      behaviorClass: svs.player_login.behaviors.Navigation
    }
  },
  initialize() {
    svs.accountservices.authenticate.login.on(AuthenticateEvents.READY_TO_POLL, this.onReadyToPoll, this);
  },
  onSsnSubmit() {
    svs.accountservices.authenticate.login.start({
      ssn: this.model.get('ssn'),
      codeChallenge: this.model.get('codeChallenge'),
      codeChallengeMethod: this.model.get('codeChallengeMethod'),
      isCustomerRegistration: this.model.get('isCustomerRegistration'),
      isPoker: this.model.get('isPoker')
    });
  },
  onReadyToPoll(data) {
    this.model.set('loginToken', data.loginToken);
    svs.player_login.router.navigate("bankid/poll?".concat(this.model.toQueryString()), true);
  },
  onDestroy() {
    svs.accountservices.authenticate.login.off(AuthenticateEvents.READY_TO_POLL, this.onReadyToPoll);
  }
});

 })(window);